import React, { useEffect, useState } from 'react'
import { createMicrophoneAudioTrack } from 'agora-rtc-react'
import { createClient } from 'agora-rtc-react'
import styles from './Floating.module.scss'
import Controls from '../AudioVideoCallComponent/Controls'
import { FaMicrophoneSlash } from 'react-icons/fa6'
import useAgoraUsers from 'hooks/useAgora'
import { useNavigate } from 'react-router-dom'
import { images } from 'theme'
import { useSelector, useDispatch } from 'react-redux'
import { database, databaseRef } from 'utils/firebase'
import { get, child } from 'firebase/database'
import { actions as manageCallActions } from 'slices/manageCall.slice'

const config = { mode: 'rtc', codec: 'vp8' }
const useClient = createClient(config)
const useMicrophoneAudioTrack = createMicrophoneAudioTrack()

const FloatingAudioCall = ({appId}) => {
  const dispatch = useDispatch()

  const navigate = useNavigate()
  const client =  useClient()

  const [ patientProfileImage,setPatientProfileImage ] = useState(null);
  const { manageCallData, callJoiningStatus } = useSelector((state) => state.callData)
  const { channelName, account, engageCall, callType } = manageCallData
  const { ready, track, error } = useMicrophoneAudioTrack()

  const {
    users,
    agoraInstance,
    time: timing,
    options: currentOption,
    initialNameLetters,
    remoteConnectionState,
    callStart
  } = useAgoraUsers()

  useEffect(() => {
    console.log("callJoiningStatus ", callJoiningStatus)
  },[callJoiningStatus]);

  const { nextMode,currentSession } = useSelector(
    (state) => state.mentalHealth,
  )
  // const [remoteConnectionState, setRemoteConnectionState] = useState({
  //   audio: false,
  //   video: true,
  // })

  const setCallJoiningStatus = (status) => {
    dispatch(manageCallActions.setCallJoiningStatus(status))
  }

  const initializeAgora = async () => {
    if (manageCallData?.engageCall) {
      if(!agoraInstance.client) agoraInstance.client = client
      if(!agoraInstance.appId) agoraInstance.appId = appId
      if(!agoraInstance.channelName) agoraInstance.channelName = channelName
      if(!agoraInstance.token) agoraInstance.token = manageCallData?.token
      if(!agoraInstance.account) agoraInstance.account = account
      if(!agoraInstance?.tracks) agoraInstance.tracks = track
      agoraInstance.ready = ready
      await agoraInstance.init(channelName, setCallJoiningStatus)
    }
  }
  useEffect(() => {
    if (ready && track && !callStart && !callJoiningStatus) {
      initializeAgora().catch((error) => {
        console.error('AGORRAAA Failed to initialize Agora:', error)
      });
    }
  }, [ ready, track, manageCallData, callJoiningStatus ])

  // const updateUsers = (newUsers) => {
  //   if (newUsers) {
  //     setUsers([...newUsers])
  //   }
  // }
  const getPatientProfilePicture = async (patientId, owner) => {
    // Determine the path to the profile picture
    const profilePicturePath = owner
      ? `/users/${patientId}/profiles/${owner}/profile_image`
      : `/users/${patientId}/profile_image`

    try {
      const snapshot = await get(
        child(databaseRef(database), profilePicturePath),
      )
      if (snapshot.exists()) {
        const profileImage = snapshot.val()
        console.log(profileImage)

        setPatientProfileImage(profileImage) // Update state with the profile image
      } else {
        // Handle case where no profile image exists
      }
    } catch (error) {
      console.error('Error fetching patient profile picture:', error);
    }
  };

  useEffect(()=>{
    console.log("Logging",currentSession);
    
    if (currentSession?.patientID) {
      getPatientProfilePicture(
        currentSession.patientID,
        currentSession.owner
      );
    }
  },[currentSession])


  // useEffect(() => {
  //   if (start) {
  //     agoraInstance.addObserver('users', updateUsers)
  //   }
  // }, [initialNameLetters, track, ready, callStart])

  // useEffect(() => {
  //   setStart(agoraInstance.start)
  //   setRemoteConnectionState(agoraInstance.remoteConnectionState)
  // }, [agoraInstance.start, agoraInstance.remoteConnectionState])

  function formatTime(timeInSeconds) {
    const hours = Math.floor(timeInSeconds / 3600)
    const minutes = Math.floor((timeInSeconds % 3600) / 60)
    const seconds = timeInSeconds % 60

    const paddedHours = String(hours).padStart(2, '0')
    const paddedMinutes = String(minutes).padStart(2, '0')
    const paddedSeconds = String(seconds).padStart(2, '0')

    return `${paddedHours}:${paddedMinutes}:${paddedSeconds}`
  }

  // const initializeAgora = async () => {
  //   if (manageCallData?.engageCall) {
  //     if(!agoraInstance.client) agoraInstance.client = client
  //     if(!agoraInstance.appId) agoraInstance.appId = appId
  //     if(!agoraInstance.channelName) agoraInstance.channelName = channelName
  //     if(!agoraInstance.token) agoraInstance.token = manageCallData?.token
  //     if(!agoraInstance.account) agoraInstance.account = account
  //     if(!agoraInstance?.tracks) agoraInstance.tracks = tracks
  //     agoraInstance.ready = ready
  //     await agoraInstance.init(channelName)
  //   }
  // }
  // useEffect(() => {
    

  //   if (ready && track && !start) {
  //     initializeAgora().catch((error) => {
  //       console.error('AGORRAAA Failed to initialize Agora:', error)
  //     });
  //   }
  // }, [ ready, tracks, manageCallData ])


  return (
    <>
      {engageCall && (
        <div className={styles.audioContainer}>
          {engageCall && ready &&
            track && (
            users.length > 0 ?
            users.map((user) => {
              if (user) {
                return (
                  <div className={styles.audioCall}>
                    <div className={styles.audioListening}>
                      <span className={styles.audioTag}>{currentOption}</span>
                      <span className={styles.audioTag}>
                        {formatTime(timing)}
                      </span>
                    </div>

                    <div className={styles.audioLogo}>
                      <img
                        src={patientProfileImage || images.calIcon}
                        className={styles.image}
                        alt="icon"
                      />
                      <span className={styles.ringing}>Ongoing call</span>
                      {!remoteConnectionState.audio && <FaMicrophoneSlash />}
                    </div>
                  {nextMode &&
                    <div className={styles.audioUpNext}>
                      <span className={styles.next}>Up next </span>
                      <span className={styles.planing}>
                        {nextMode}
                      </span>
                    </div>
                    }
                    <div className={styles.callButtons}>
                      <Controls
                        track={track}
                        id={channelName}
                        // setInCall={setInCall}
                        client={client}
                        type={'audioCall'}
                      />
                    </div>
                  </div>
                )
              }
            }) : (
              <div className={styles.audioCall}>
                <div className={styles.audioLogo}>
                  <img
                    src={patientProfileImage || images.calIcon}
                    className={styles.image}
                    alt="icon"
                  />
                  <span className={styles.ringing}>Ringing</span>
                  {!remoteConnectionState.audio && <FaMicrophoneSlash />}
                </div>
              
                <div className={styles.callButtons}>
                  <Controls
                    track={track}
                    id={channelName}
                    // setInCall={setInCall}
                    client={client}
                    type={'audioCall'}
                  />
                </div>
              </div>
            )
            )}
        </div>
      )}
    </>
  )
}

export default FloatingAudioCall
